import { Link } from 'react-router-dom';
import { Home, LogIn } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-mp-bg-pink flex items-center justify-center p-4 font-body">
      <div className="relative max-w-md w-full text-center">
        <img
          src="/mikkel-tenker.png"
          alt="Mikkel tenker"
          className="w-32 h-32 mx-auto mb-6 object-contain -rotate-6"
        />

        <span className="mp-eyebrow">404 · Hjelp</span>
        <h1 className="font-display text-mp-darkgreen text-[40px] mt-2 mb-3">
          Hmm — denne sida finn me ikkje
        </h1>
        <p className="text-mp-stone-700 mb-8">
          Sida du leitar etter finst ikkje, eller har blitt flytta. Mikkel klør seg i hovudet.
        </p>

        <div className="flex flex-col gap-3 max-w-xs mx-auto">
          <Link to="/" className="mp-cta w-full">
            <Home size={20} />
            <span>Gå til startsida</span>
          </Link>
          <Link
            to="/join"
            className="inline-flex items-center justify-center gap-2 w-full py-3 px-6 rounded-full bg-white border border-[rgba(17,73,66,0.20)] text-mp-darkgreen font-display font-bold hover:bg-mp-bg-lightgreen transition-colors"
          >
            <LogIn size={20} />
            Bli med i ein kviss
          </Link>
        </div>
      </div>
    </div>
  );
}
